'use client';

import { useMemo } from 'react';
import type { ChinaEnvironment } from '../utils/constants';
import { typeEnvironments } from '../utils/interfaces';
import { EnvironmentContext } from './contexts/EnvironmentContext';

export type EnvironmentContextProviderProps = {
  env: typeEnvironments | ChinaEnvironment;
  datadogClientToken: string;
  datadogApplicationId: string;
  scanditKey: string;
  configuratordataproviderBasePath: string;
  productconfigurationBasePath: string;
  productmeasurementBasePath: string;
  addToCartWebstoreUrlTemplate: string;
  configurationImagesBasePath: string;
  createconfiguredproductimagePath: string;
  cacheBasePath: string;
  bookingToolServiceId: string;
  cdnDomain: string;
  cmWebstoreOrigin: string;
  datadogAppVersion: string;
  datadogSessionSampleRate: number;
  datadogSessionReplaySampleRate: number;
  datadogLogsSampleRate: number;
  children: React.ReactNode;
};

const EnvironmentContextProvider = ({
  env,
  datadogClientToken,
  datadogApplicationId,
  scanditKey,
  configuratordataproviderBasePath,
  productconfigurationBasePath,
  productmeasurementBasePath,
  addToCartWebstoreUrlTemplate,
  configurationImagesBasePath,
  createconfiguredproductimagePath,
  cacheBasePath,
  bookingToolServiceId,
  cdnDomain,
  cmWebstoreOrigin,
  datadogAppVersion,
  datadogSessionSampleRate,
  datadogSessionReplaySampleRate,
  datadogLogsSampleRate,
  children,
}: EnvironmentContextProviderProps) => {
  const environmentContext = useMemo(
    () => ({
      env,
          datadogClientToken,
      datadogApplicationId,
      scanditKey,
      configuratordataproviderBasePath,
      productconfigurationBasePath,
      productmeasurementBasePath,
      addToCartWebstoreUrlTemplate,
      configurationImagesBasePath,
      createconfiguredproductimagePath,
      cacheBasePath,
      bookingToolServiceId,
      cdnDomain,
      cmWebstoreOrigin,
      datadogAppVersion,
      datadogSessionSampleRate,
      datadogSessionReplaySampleRate,
      datadogLogsSampleRate,
    }),
    [
      env,
          datadogClientToken,
      datadogApplicationId,
      scanditKey,
      configuratordataproviderBasePath,
      productconfigurationBasePath,
      productmeasurementBasePath,
      addToCartWebstoreUrlTemplate,
      configurationImagesBasePath,
      createconfiguredproductimagePath,
      cacheBasePath,
      bookingToolServiceId,
      cdnDomain,
      cmWebstoreOrigin,
      datadogAppVersion,
      datadogSessionSampleRate,
      datadogSessionReplaySampleRate,
      datadogLogsSampleRate,
    ],
  );
  return <EnvironmentContext.Provider value={environmentContext}>{children}</EnvironmentContext.Provider>;
};

export default EnvironmentContextProvider;
